// react
import React, { Suspense } from "react";

// components
import Spinner from "../../../components/Spinner/ComponentLoader";

// load in the goal tree
const LazyEditAutoflow = React.lazy(() => import("./EditAutoflow"));

const EditAutoflowLazyLoader = () => (
	<Suspense fallback={<Spinner />}>
		<LazyEditAutoflow />
	</Suspense>
);

export default EditAutoflowLazyLoader;
